import React, { Fragment, ReactNode } from 'react';

import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { DrawerProps } from 'antd';

import { StyledDrawer } from './custom-drawer.styles';

const DrawerComponent = ({subtitle, children, ...rest }: DrawerProps & { children?: ReactNode; subtitle?: string }) => {
  return (
    <StyledDrawer
      extra={
        <Fragment>
          {subtitle && (
            <Typography color={PLATFORM_THEME_COLORS.primary.grey}>{subtitle}</Typography>
          )}
        </Fragment>
      }
      {...rest}
    >
      {children}
    </StyledDrawer>
  );
};

export default DrawerComponent;
